<script lang="ts" setup>
  defineProps<{
    title?: string
  }>()
</script>

<template>
  <div class="page-container">
    <div
      v-if="title"
      class="page-container__title heading-md text-heading!"
    >
      {{ title }}
    </div>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  .page-container {
    @include flex-container(column, flex-start, flex-start);
    width: 100%;
    height: 100%;
  }
  .page-container__title {
    margin-bottom: 24px;
  }

  @include mobile {
    .page-container__title {
      padding-left: 12px;
      margin-bottom: 16px;
    }
  }
</style>
